import { logger } from '@/modules/utils'

import { AUTH_CALLBACK_PATH } from './constants'

const OIDC_RECOVERY_KEY = 'oidc_state_recovery'

export const isStaleOidcStateError = (error: Error): boolean =>
  error.message.toLowerCase().includes('no matching state found in storage')

export const clearRecoveryFlag = (): void =>
  sessionStorage.removeItem(OIDC_RECOVERY_KEY)

/**
 * Attempts a single recovery redirect for stale OIDC state errors.
 * Returns true if recovery was initiated (caller should render nothing),
 * or false if recovery was already attempted (caller should show error).
 */
export const attemptStaleStateRecovery = (): boolean => {
  const hasAlreadyRetried = sessionStorage.getItem(OIDC_RECOVERY_KEY) !== null

  if (hasAlreadyRetried) {
    clearRecoveryFlag()
    return false
  }

  logger.warn(
    'Stale authentication callback URL detected, restarting auth flow',
  )
  sessionStorage.setItem(OIDC_RECOVERY_KEY, '1')
  window.location.replace(AUTH_CALLBACK_PATH)
  return true
}
